import { Outlet, Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { cn } from '@creanizer/utils'
import { useSettingsStore } from '../../stores/settingsStore'
import { useDevModeStore } from '../../stores/devModeStore'
import { ApiKeyModal } from '../modules/ApiKeyModal'
import { CustomValuesModal } from '../modules/CustomValuesModal'
import { BulkDataModal } from '../modules/BulkDataModal'

export function Layout() {
  const location = useLocation()
  const { isApiKeySet, clearGeminiApiKey } = useSettingsStore()
  const { isDevMode, checkDevMode } = useDevModeStore()
  const [showApiKeyModal, setShowApiKeyModal] = useState(false)
  const [showCustomValuesModal, setShowCustomValuesModal] = useState(false)
  const [showBulkDataModal, setShowBulkDataModal] = useState(false)
  
  // URLパラメータから開発者モードをチェック
  useEffect(() => {
    checkDevMode()
  }, [location.search])

  const isActive = (path: string) => location.pathname === path

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4">
          <nav className="flex items-center justify-between h-16">
            <Link to="/" className="text-2xl font-bold text-primary-600">
              CreaNizer
            </Link>
            <div className="flex items-center gap-2 sm:gap-6">
              <button
                onClick={() => setShowBulkDataModal(true)}
                className="text-sm font-medium px-2 sm:px-3 py-1 rounded bg-blue-100 text-blue-700 hover:bg-blue-200"
              >
                📁 <span className="hidden sm:inline">データ管理</span><span className="sm:hidden">data</span>
              </button>
              <button
                onClick={() => setShowCustomValuesModal(true)}
                className="text-sm font-medium px-2 sm:px-3 py-1 rounded bg-purple-100 text-purple-700 hover:bg-purple-200"
              >
                🎨 <span className="hidden sm:inline">カスタム値管理</span><span className="sm:hidden">custom</span>
              </button>
              <button
                onClick={() => setShowApiKeyModal(true)}
                className={cn(
                  'text-sm font-medium px-2 sm:px-3 py-1 rounded',
                  isApiKeySet()
                    ? 'bg-green-100 text-green-700 hover:bg-green-200'
                    : 'bg-red-100 text-red-700 hover:bg-red-200'
                )}
              >
                {isApiKeySet() ? '🔑' : '⚠️'} <span className="hidden sm:inline">{isApiKeySet() ? 'APIキー設定済み' : 'APIキー未設定'}</span><span className="sm:hidden">API</span>
              </button>
              {isDevMode && (
                <div className="text-sm font-medium px-2 sm:px-3 py-1 rounded bg-orange-100 text-orange-700">
                  🚀 <span className="hidden sm:inline">開発者モード</span><span className="sm:hidden">dev</span>
                </div>
              )}
            </div>
          </nav>
        </div>
      </header>
      <main className="flex-1 container mx-auto px-4 py-8">
        <Outlet />
      </main>
      <footer className="bg-gray-50 border-t border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <p className="text-center text-sm text-gray-600">
            © 2024 CreaNizer. All rights reserved.
          </p>
        </div>
      </footer>
      <ApiKeyModal 
        isOpen={showApiKeyModal} 
        onClose={() => setShowApiKeyModal(false)} 
      />
      <CustomValuesModal
        isOpen={showCustomValuesModal}
        onClose={() => setShowCustomValuesModal(false)}
      />
      <BulkDataModal
        isOpen={showBulkDataModal}
        onClose={() => setShowBulkDataModal(false)}
      />
    </div>
  )
}